// Keys we explicitly render in the finding detail view
export const RENDERED_FINDING_KEYS = new Set([
  'id',
  'title',
  'type',
  'severity',
  'cwe',
  'cwe_id',
  'file_path',
  'line_range',
  'function_name',
  'confidence',
  'description',
  'code_snippet',
  'remediation',
  'cvss_score',
  'cvss_vector',
  'verification',
]);

// Keys we explicitly render in the exploit detail view
export const RENDERED_EXPLOIT_KEYS = new Set([
  'id',
  'success',
  'status',
  'reasoning',
  'poc_code',
  'success_indicators',
  'commands_summary',
  'vulnerability_report',
  'proof_markers',
  'validation_recipe',
]);

// Keys we explicitly render in the patch validation detail view
export const RENDERED_VALIDATION_KEYS = new Set([
  'option_id',
  'finding_id',
  'verdict',
  'duration_s',
  'evidence',
]);

// Keys we explicitly render in the patch option detail view
export const RENDERED_PATCH_KEYS = new Set([
  'id',
  'strategy',
  'risk_level',
  'description',
  'diff',
  'patch_file',
  'defense_layers',
  'verification',
  'edits',
]);
